export default {"src":"/_next/static/media/logo_wordmark_130x16.20edabb5.svg","height":16,"width":130,"blurWidth":0,"blurHeight":0};